<template>
  <div>
    <div v-if="model === false">
      <div class="totalmakeHole" ref="total">
        <div
          class="topback"
          :style="{ height: '6vh', backgroundColor: scrollback ? 'rgb(245 244 246)' : 'rgb(245 244 246)' }"
        >
          <headtip :changeVisable="changeVisable" @showDialog="showPartner" />
        </div>

        <div class="makeHole1" @click="changeheadVisable">
          <kefu @toptop="topTop" />

          <div class="ip-page ip-page--desktop">
            <section class="hero" id="intelligent-injection-production">
              <div class="hero-inner">
                <div class="hero-content">
                  <h1>智能注采闭环优化</h1>
                  <ul class="hero-list">
                    <li>自动识别注采失衡、无效循环水与层间动用差异</li>
                    <li>预测注水调整对产量、含水率和压力的影响</li>
                    <li>生成注水量、阀位档位、层段配比与调整时序建议</li>
                  </ul>
                  <div class="hero-actions">
                    <a class="btn" href="javascript:void(0)" @click.prevent="scrollToConsult">产品咨询</a>
                    <a class="btn" href="javascript:void(0)" @click.prevent="scrollToExperience">功能体验</a>
                  </div>
                </div>

                <div class="reservoir-visual" aria-label="智能注采闭环优化示意图">
                  <img loading="lazy" src="@/assets/injectionProductionBanner.png" alt="智能注采闭环优化示意图">
                </div>
              </div>
            </section>

            <section class="section section-blue">
              <div class="container">
                <div class="section-head">
                  <h2 class="section-title">功能介绍</h2>
                  <p class="section-desc">Well-Link 智能注采面向油田高含水阶段的注采平衡问题，打通注水井、采油井、层段与井网关系，让注采调整从经验判断升级为模型辅助决策。</p>
                </div>

                <div class="intro-layout">
                  <div class="intro-card">
                    <h3>不是多一张报表，而是一套闭环能力</h3>
                    <p>系统围绕"看清现场、算准响应、生成方案、跟踪执行"四个环节，帮助工程师快速定位问题、制定调整方案并复盘优化效果。</p>
                  </div>

                  <div class="intro-steps">
                    <div class="step-card">
                      <div class="step-no">01</div>
                      <h3>看清现场</h3>
                      <p>汇聚注水、采出、压力、含水、阀位等动态数据。</p>
                    </div>
                    <div class="step-card">
                      <div class="step-no">02</div>
                      <h3>预测响应</h3>
                      <p>判断调整后产量、含水率和压力变化趋势。</p>
                    </div>
                    <div class="step-card">
                      <div class="step-no">03</div>
                      <h3>生成方案</h3>
                      <p>输出注水量、层段配比、阀位档位等建议。</p>
                    </div>
                    <div class="step-card">
                      <div class="step-no">04</div>
                      <h3>闭环复盘</h3>
                      <p>跟踪方案执行结果，支撑滚动优化。</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section class="section section-white" id="experience" ref="experience">
              <div class="container">
                <div class="section-head">
                  <h2 class="section-title">核心功能</h2>
                </div>

                <div class="experience-grid">
                  <article class="experience-card">
                    <div class="icon-box">01</div>
                    <h3>注采参数预测</h3>
                    <p>融合生产动态、层位、孔渗和井筒信息，预测不同调整对井组动态的影响。</p>
                    <span class="solve">判断：调整后会不会有效？</span>
                  </article>

                  <article class="experience-card">
                    <div class="icon-box">02</div>
                    <h3>注采参数优化</h3>
                    <p>在产量、含水、压力和设备约束之间综合计算，生成可执行的优化建议。</p>
                    <span class="solve">回答：怎么调更优、更稳？</span>
                  </article>

                  <article class="experience-card">
                    <div class="icon-box">03</div>
                    <h3>执行回执复盘</h3>
                    <p>对接现场控制系统，跟踪方案下发、执行回执和效果变化，形成持续优化。</p>
                    <span class="solve">确认：方案是否落地、效果如何？</span>
                  </article>
                </div>
              </div>
            </section>

            <section class="section section-soft">
              <div class="container">
                <div class="section-head">
                  <h2 class="section-title">注采管理闭环流程</h2>
                  <p class="section-desc">从问题识别到现场执行，形成清晰、可追踪、可复盘的业务链路。</p>
                </div>

                <div class="flow-panel">
                  <div class="flow-copy">
                    <h3>数据 + 模型 + 优化 + 执行</h3>
                    <p>让注采管理不再停留在离线分析和人工流转，而是进入可持续优化的现场闭环。</p>
                  </div>

                  <div class="flow-steps">
                    <div class="flow-step">
                      <strong>STEP 01</strong>
                      <h3>数据感知</h3>
                      <p>识别注采失衡、异常波动和低效循环。</p>
                    </div>
                    <div class="flow-step">
                      <strong>STEP 02</strong>
                      <h3>模型预测</h3>
                      <p>预测注采调整后的动态响应。</p>
                    </div>
                    <div class="flow-step">
                      <strong>STEP 03</strong>
                      <h3>方案优化</h3>
                      <p>生成注水量、阀位和层段建议。</p>
                    </div>
                    <div class="flow-step">
                      <strong>STEP 04</strong>
                      <h3>执行复盘</h3>
                      <p>跟踪执行结果并滚动优化。</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section class="section section-dark" id="consult" ref="consult">
              <div class="container">
                <div class="section-head">
                  <h2 class="section-title section-title--light">应用价值</h2>
                  <p class="section-desc section-desc--light">最终目标是让注采管理更准、更稳、更快、更清楚。</p>
                </div>

                <div class="value-grid">
                  <div class="value-card">
                    <strong>注得更准</strong>
                    <span>减少无效循环，提升有效注入比例。</span>
                  </div>
                  <div class="value-card">
                    <strong>采得更稳</strong>
                    <span>平衡井组供采关系，降低波动风险。</span>
                  </div>
                  <div class="value-card">
                    <strong>调得更快</strong>
                    <span>缩短人工分析与方案流转周期。</span>
                  </div>
                  <div class="value-card">
                    <strong>管得更清楚</strong>
                    <span>执行、回执、复盘全过程可追踪。</span>
                  </div>
                </div>

                <div class="cta">
                  <div>
                    <h2>让注采管理进入智能闭环</h2>
                    <p>连接井下、地面与开发决策，让数据参与判断，让模型服务生产，让方案真正走向现场。</p>
                  </div>
                  <a class="btn btn--cta" href="javascript:void(0)" @click.prevent="clickConsult('油气通')">预约产品咨询</a>
                </div>
              </div>
            </section>
          </div>

          <bottomTip />
        </div>
      </div>
    </div>

    <div v-else>
      <div class="totalModel" ref="totalModel">
        <div class="screen1">
          <kefuMobile @topMobile="topTopmobile" />
          <headtip @showDialog="showPartner" />
          <div class="layer2">
            <div class="title1">智能注采闭环优化</div>
            <div class="title2">
              <li>自动识别注采失衡与无效循环水</li>
              <li>预测注水调整对产量、含水和压力的影响</li>
              <li>生成注水量、阀位和层段配比优化建议</li>
            </div>
          </div>
          <div class="hero-actions-mobile">
            <div class="titlle3" @click="clickConsult('油气通')">产品咨询</div>
            <div class="titlle3 titlle3--outline" @click="scrollToExperience">功能体验</div>
          </div>
        </div>

        <div class="screenmake0">
          <div class="reservoir-visual reservoir-visual--mobile" aria-label="智能注采闭环优化示意图">
            <img loading="lazy" src="@/assets/injectionProductionBanner.png" alt="智能注采闭环优化示意图">
          </div>
        </div>

        <div class="screenmake2">
          <div class="heighLight">功能介绍</div>
          <div class="heightLight2">
            Well-Link 智能注采面向油田高含水阶段的注采平衡问题，打通注水井、采油井、层段与井网关系，让注采调整从经验判断升级为模型辅助决策。
          </div>
          <div class="grid">
            <div class="card">
              <div class="back back--dark">
                <div class="titleDesign">
                  <div class="Title1">不是多一张报表，而是一套闭环能力</div>
                  <div class="Title2">
                    系统围绕"看清现场、算准响应、生成方案、跟踪执行"四个环节，帮助工程师快速定位问题、制定调整方案并复盘优化效果。
                  </div>
                </div>
              </div>
            </div>
            <div class="card" v-for="item in introSteps" :key="item.no">
              <div class="back">
                <div class="titleDesign">
                  <div class="Title1"><span class="step-badge">{{ item.no }}</span>{{ item.title }}</div>
                  <div class="Title2">{{ item.desc }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="screenmake2" ref="experience">
          <div class="heighLight">核心功能</div>
          <div class="grid">
            <div class="card" v-for="item in coreFeatures" :key="item.no">
              <div class="back">
                <div class="titleDesign">
                  <div class="Title1"><span class="step-badge">{{ item.no }}</span>{{ item.title }}</div>
                  <div class="Title2">{{ item.desc }}</div>
                  <div class="solve-tag">{{ item.solve }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="screenmake2 screenmake2--soft">
          <div class="heighLight">注采管理闭环流程</div>
          <div class="heightLight2">从问题识别到现场执行，形成清晰、可追踪、可复盘的业务链路。</div>
          <div class="grid">
            <div class="card">
              <div class="back back--dark">
                <div class="titleDesign">
                  <div class="Title1">数据 + 模型 + 优化 + 执行</div>
                  <div class="Title2">让注采管理不再停留在离线分析和人工流转，而是进入可持续优化的现场闭环。</div>
                </div>
              </div>
            </div>
            <div class="card" v-for="item in flowSteps" :key="item.no">
              <div class="back">
                <div class="titleDesign">
                  <div class="Title1">{{ item.no }} {{ item.title }}</div>
                  <div class="Title2">{{ item.desc }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="screenmake2 screenmake2--dark" ref="consult">
          <div class="heighLight heighLight--light">应用价值</div>
          <div class="heightLight2 heightLight2--light">最终目标是让注采管理更准、更稳、更快、更清楚。</div>
          <div class="grid">
            <div class="card" v-for="item in valueItems" :key="item.title">
              <div class="back back--value">
                <div class="titleDesign">
                  <div class="Title1">{{ item.title }}</div>
                  <div class="Title2">{{ item.desc }}</div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="back back--cta">
                <div class="titleDesign">
                  <div class="Title1">让注采管理进入智能闭环</div>
                  <div class="Title2">连接井下、地面与开发决策，让数据参与判断，让模型服务生产，让方案真正走向现场。</div>
                  <div class="titlle3 titlle3--cta" @click="clickConsult('油气通')">预约产品咨询</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <bottomTip />
      </div>
    </div>

    <partnerTip :dialogVisible="dialogconsult" @hideDialog="hide" />
    <consultTip
      :dialogVisible="dialogVisible"
      :thisTitle="title"
      @hideDialog="hideDialog"
    />
  </div>
</template>

<script>
import headtip from '@/views/headTip.vue'
import bottomTip from '@/views/bottomTip.vue'
import consultTip from '@/components/consultTip.vue'
import PartnerTip from '@/components/partnerTip.vue'
import kefu from '@/views/kefu.vue'
import kefuMobile from '@/views/kefuMobile.vue'
import { shareUrl } from '@/utils/vxshare'

export default {
  name: 'injectionProduction',
  components: {
    PartnerTip,
    consultTip,
    headtip,
    bottomTip,
    kefu,
    kefuMobile
  },
  data() {
    return {
      changeVisable: 1,
      title: '',
      model: false,
      dialogconsult: false,
      scrollback: false,
      dialogVisible: false,
      pageTitle: '智能注采闭环优化-油气通GPT',
      pageDescription: '智能注采面向油田高含水阶段的注采平衡问题，打通注水井、采油井、层段与井网关系，让注采调整从经验判断升级为模型辅助决策。',
      pageKeywords: '智能注采闭环优化，注采参数预测，注采参数优化，生产工艺优化GPTs，智能注采决策，油气通，油气通GPT，油气通GPT云平台，油气通大模型，油气通GPT大模型',
      introSteps: [
        { no: '01', title: '看清现场', desc: '汇聚注水、采出、压力、含水、阀位等动态数据。' },
        { no: '02', title: '预测响应', desc: '判断调整后产量、含水率和压力变化趋势。' },
        { no: '03', title: '生成方案', desc: '输出注水量、层段配比、阀位档位等建议。' },
        { no: '04', title: '闭环复盘', desc: '跟踪方案执行结果，支撑滚动优化。' }
      ],
      coreFeatures: [
        { no: '01', title: '注采参数预测', desc: '融合生产动态、层位、孔渗和井筒信息，预测不同调整对井组动态的影响。', solve: '判断：调整后会不会有效？' },
        { no: '02', title: '注采参数优化', desc: '在产量、含水、压力和设备约束之间综合计算，生成可执行的优化建议。', solve: '回答：怎么调更优、更稳？' },
        { no: '03', title: '执行回执复盘', desc: '对接现场控制系统，跟踪方案下发、执行回执和效果变化，形成持续优化。', solve: '确认：方案是否落地、效果如何？' }
      ],
      flowSteps: [
        { no: 'STEP 01', title: '数据感知', desc: '识别注采失衡、异常波动和低效循环。' },
        { no: 'STEP 02', title: '模型预测', desc: '预测注采调整后的动态响应。' },
        { no: 'STEP 03', title: '方案优化', desc: '生成注水量、阀位和层段建议。' },
        { no: 'STEP 04', title: '执行复盘', desc: '跟踪执行结果并滚动优化。' }
      ],
      valueItems: [
        { title: '注得更准', desc: '减少无效循环，提升有效注入比例。' },
        { title: '采得更稳', desc: '平衡井组供采关系，降低波动风险。' },
        { title: '调得更快', desc: '缩短人工分析与方案流转周期。' },
        { title: '管得更清楚', desc: '执行、回执、复盘全过程可追踪。' }
      ]
    }
  },
  methods: {
    topTopmobile() {
      const ref = this.model ? this.$refs.totalModel : this.$refs.total
      if (ref) {
        ref.scrollTop = 0
      }
    },
    topTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    changeheadVisable() {
      this.changeVisable = this.changeVisable === 1 ? 0 : 1
    },
    clickConsult(item) {
      this.title = item
      this.dialogVisible = true
      sessionStorage.setItem('title', item)
    },
    hide() {
      this.dialogconsult = false
    },
    hideDialog() {
      this.dialogVisible = false
    },
    showPartner() {
      this.dialogconsult = true
    },
    scrollToSection(refName) {
      const section = this.$refs[refName]
      if (!section) return
      section.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
    scrollToExperience() {
      this.scrollToSection('experience')
    },
    scrollToConsult() {
      this.scrollToSection('consult')
    },
    handleScroll() {
      const ref = this.model ? this.$refs.totalModel : this.$refs.total
      if (!ref) return
      this.scrollback = ref.scrollTop >= 350
    },
    setMetaTags() {
      const metaDescription = document.querySelector('meta[name="description"]')
      if (metaDescription) {
        metaDescription.setAttribute('content', this.pageDescription)
      }

      const metaKeywords = document.querySelector('meta[name="keywords"]')
      if (metaKeywords) {
        metaKeywords.setAttribute('content', this.pageKeywords)
      }
    }
  },
  mounted() {
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    this.model = screenWidth <= 700

    this.$nextTick(() => {
      const ref = this.model ? this.$refs.totalModel : this.$refs.total
      if (ref) {
        ref.addEventListener('scroll', this.handleScroll)
      }
    })

    document.title = this.pageTitle
    this.setMetaTags()
    localStorage.setItem('home', 0)

    const url = window.location.href
    setTimeout(() => {
      shareUrl({
        url,
        pageTitle: this.pageTitle,
        pageDescription: this.pageDescription,
        pageKeywords: this.pageKeywords
      })
    }, 1000)

    document.dispatchEvent(new Event('render-event'))
  },
  beforeDestroy() {
    const ref = this.model ? this.$refs.totalModel : this.$refs.total
    if (ref) {
      ref.removeEventListener('scroll', this.handleScroll)
    }
  }
}
</script>

<style lang="scss" scoped>
.totalmakeHole {
  background: #fff;
  overflow-x: hidden;
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  position: relative;

  .topback {
    position: sticky;
    top: 0;
    z-index: 999;
    width: 100%;
    padding: 0 0 0 2.86077411900635vw;
    box-sizing: border-box;
  }
}

.totalModel {
  background: #ebf1fd;
  overflow-x: hidden;
  width: 100vw;
  position: relative;

  .screen1 {
    position: relative;
    width: 100%;
    padding: 12px 15px 20px;
    background: linear-gradient(90deg, #dfeeff 0%, #eaf4ff 42%, #d5e6f5 100%);

    .layer2 {
      margin-top: 50px;

      .title1 {
        margin: 0 auto;
        width: fit-content;
        text-align: center;
        font-size: 23px;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 700;
        color: #252f87;
        line-height: 28px;
      }

      .title2 {
        margin: 16px auto 0;
        width: 92%;
        text-align: left;
        font-size: 14px;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        color: #252f87;
        line-height: 22px;
        list-style: none;
        padding: 0;

        li {
          position: relative;
          margin-bottom: 8px;
          padding-left: 14px;

          &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 9px;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #252f87;
          }
        }
      }
    }

    .hero-actions-mobile {
      display: flex;
      justify-content: center;
      gap: 12px;
      margin-top: 18px;
      flex-wrap: wrap;
    }

    .titlle3 {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 15px;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      font-weight: 600;
      color: #fff;
      border-radius: 8px;
      padding: 10px 20px;
      background: #2f72ff;
      border: 1px solid #2f72ff;

      &--outline {
        background: transparent;
        color: #2f72ff;
      }

      &--cta {
        width: fit-content;
        margin-top: 14px;
      }
    }
  }

  .screenmake0 {
    padding: 16px 15px;
    background: #fff;
  }

  .screenmake2 {
    padding: 20px 15px;
    width: 100%;
    background: #fdfdfd;

    &--soft {
      background: #f0f7ff;
    }

    &--dark {
      background: linear-gradient(120deg, #0a3357 0%, #0b4b73 56%, #103b68 100%);
    }

    .heighLight {
      text-align: center;
      font-size: 21px;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      font-weight: 700;
      line-height: 26px;
      color: #111;

      &--light {
        color: #fff;
      }
    }

    .heightLight2 {
      margin: 14px 0 0;
      text-align: justify;
      font-size: 14px;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      font-weight: 400;
      color: #657386;
      line-height: 22px;

      &--light {
        color: rgba(255, 255, 255, 0.78);
        text-align: center;
      }
    }

    .grid {
      margin-top: 16px;
      display: grid;
      grid-template-columns: minmax(0, 1fr);
      row-gap: 12px;
    }

    .card {
      width: 100%;

      .back {
        border-radius: 12px;
        padding: 16px;
        background: #fff;
        border: 1px solid #e5ecf5;
        box-shadow: 0 6px 18px rgba(16, 43, 92, 0.06);

        .titleDesign {
          .Title1 {
            font-size: 16px;
            font-weight: 700;
            color: #142033;
            line-height: 24px;
            margin-bottom: 8px;
          }

          .Title2 {
            font-size: 14px;
            font-weight: 400;
            color: #657386;
            line-height: 22px;
          }
        }

        &--dark {
          background: linear-gradient(160deg, #0f4f7c 0%, #0a3357 100%);
          border: none;

          .titleDesign {
            .Title1 {
              color: #fff;
            }

            .Title2 {
              color: rgba(255, 255, 255, 0.9);
            }
          }
        }

        &--value {
          background: rgba(255, 255, 255, 0.12);
          border: 1px solid rgba(255, 255, 255, 0.28);

          .titleDesign {
            .Title1 {
              color: #fff;
              font-size: 20px;
              text-align: center;
            }

            .Title2 {
              color: rgba(255, 255, 255, 0.88);
              text-align: center;
            }
          }
        }

        &--cta {
          background: rgba(255, 255, 255, 0.12);
          border: 1px solid rgba(255, 255, 255, 0.2);

          .titleDesign {
            .Title1 {
              color: #fff;
            }

            .Title2 {
              color: rgba(255, 255, 255, 0.88);
            }

            .titlle3--cta {
              cursor: pointer;
              display: inline-flex;
              justify-content: center;
              align-items: center;
              width: fit-content;
              min-width: 160px;
              margin-top: 18px;
              padding: 12px 28px;
              border-radius: 8px;
              background: #fff;
              color: #0d4f7a;
              font-size: 16px;
              font-family: Sarial, sans-serif, "Microsoft Yahei";
              font-weight: 700;
              line-height: 1.2;
              box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18);
              border: none;
            }
          }
        }
      }

      .step-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        margin-right: 8px;
        border-radius: 8px;
        background: #eaf3ff;
        color: #0d4f7a;
        font-size: 12px;
        font-weight: 700;
        vertical-align: middle;
      }

      .solve-tag {
        display: inline-flex;
        margin-top: 12px;
        padding: 6px 10px;
        border-radius: 999px;
        background: #fff5e6;
        color: #a55a00;
        font-size: 12px;
        font-weight: 700;
      }
    }
  }

  .reservoir-visual--mobile {
    position: relative;
    height: 220px;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 12px 28px rgba(22, 52, 86, 0.18);
    background: #0f172a;

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

.ip-page {
  --navy: #102b5c;
  --blue: #2f72ff;
  --deep-blue: #0d4f7a;
  --cyan: #3bb7d8;
  --text: #142033;
  --muted: #657386;
  --line: #e5ecf5;
  --shadow: 0 16px 42px rgba(16, 43, 92, 0.10);
  --soft-shadow: 0 10px 28px rgba(16, 43, 92, 0.07);

  color: var(--text);
  line-height: 1.7;
  font-family: "Microsoft YaHei", "PingFang SC", Arial, sans-serif;

  &--desktop {
    padding-top: 0;
  }

  a {
    color: inherit;
    text-decoration: none;
    cursor: pointer;
  }

  .container {
    width: min(1180px, calc(100% - 40px));
    margin: 0 auto;
  }

  .hero {
    min-height: 430px;
    background: linear-gradient(90deg, #dfeeff 0%, #eaf4ff 42%, #d5e6f5 100%);
    overflow: hidden;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      right: -120px;
      bottom: -150px;
      width: 520px;
      height: 520px;
      border-radius: 50%;
      background: rgba(47, 114, 255, 0.08);
    }
  }

  .hero-inner {
    width: min(1280px, calc(100% - 80px));
    margin: 0 auto;
    min-height: 430px;
    display: grid;
    grid-template-columns: 0.95fr 1.25fr;
    gap: 40px;
    align-items: center;
    position: relative;
    z-index: 1;
  }

  .hero h1 {
    margin: 0 0 26px;
    color: #252f87;
    font-size: 44px;
    line-height: 1.18;
    font-weight: 900;
    letter-spacing: 0.5px;
  }

  .hero-list {
    margin: 0 0 36px;
    padding: 0;
    list-style: none;
  }

  .hero-list li {
    position: relative;
    margin-bottom: 18px;
    padding-left: 30px;
    color: #252f87;
    font-size: 21px;
    line-height: 1.55;
    font-weight: 800;
  }

  .hero-list li::before {
    content: "";
    position: absolute;
    left: 0;
    top: 16px;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: #252f87;
  }

  .hero-actions {
    display: flex;
    gap: 28px;
    flex-wrap: wrap;
  }

  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 138px;
    height: 46px;
    padding: 0 24px;
    border-radius: 8px;
    background: var(--blue);
    color: #fff;
    font-size: 20px;
    font-weight: 800;
    box-shadow: 0 10px 24px rgba(47, 114, 255, 0.22);
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 14px 28px rgba(47, 114, 255, 0.28);
    }

    &--cta {
      background: #fff;
      color: var(--deep-blue);
      box-shadow: none;
      flex: 0 0 auto;
    }
  }

  .reservoir-visual {
    position: relative;
    height: 350px;
    border-radius: 22px;
    overflow: hidden;
    box-shadow: 0 24px 56px rgba(22, 52, 86, 0.24);
    background: #0f172a;

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .section {
    position: relative;
    padding: 74px 0;
  }

  .section-blue {
    background: linear-gradient(180deg, #f0f7ff 0%, #f7fbff 100%);
  }

  .section-white {
    background: #fff;
  }

  .section-soft {
    background:
      radial-gradient(circle at 20% 10%, rgba(47, 114, 255, 0.07), transparent 26%),
      linear-gradient(180deg, #f8fbff 0%, #eef6ff 100%);
  }

  .section-dark {
    padding: 72px 0 80px;
    background:
      radial-gradient(circle at 15% 0%, rgba(59, 183, 216, 0.20), transparent 28%),
      linear-gradient(120deg, #0a3357 0%, #0b4b73 56%, #103b68 100%);
    color: #fff;
  }

  .section-white::before,
  .section-soft::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: -1px;
    height: 34px;
    background: inherit;
    clip-path: polygon(0 0, 100% 0, 100% 58%, 0 100%);
    z-index: 0;
  }

  .section > .container {
    position: relative;
    z-index: 1;
  }

  .section-head {
    margin-bottom: 36px;
    text-align: center;
  }

  .section-title {
    margin: 0;
    font-size: 38px;
    line-height: 1.2;
    font-weight: 900;
    color: #142033;
    letter-spacing: -0.3px;

    &--light {
      color: #fff;
    }
  }

  .section-desc {
    max-width: 790px;
    margin: 16px auto 0;
    color: var(--muted);
    font-size: 17px;
    font-weight: 600;

    &--light {
      color: rgba(255, 255, 255, 0.72);
    }
  }

  .intro-layout {
    display: grid;
    grid-template-columns: 0.85fr 1.15fr;
    gap: 26px;
    align-items: stretch;
  }

  .intro-card {
    padding: 34px;
    border-radius: 26px;
    background: linear-gradient(160deg, #0f4f7c 0%, #0a3357 100%);
    color: #fff;
    box-shadow: var(--shadow);
    overflow: hidden;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      right: -72px;
      bottom: -72px;
      width: 180px;
      height: 180px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.08);
    }

    h3 {
      margin: 0 0 18px;
      font-size: 28px;
      line-height: 1.25;
      font-weight: 900;
    }

    p {
      margin: 0;
      color: rgba(255, 255, 255, 0.82);
      font-size: 17px;
      font-weight: 600;
    }
  }

  .intro-steps {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }

  .step-card {
    padding: 24px;
    border-radius: 22px;
    background: rgba(255, 255, 255, 0.88);
    border: 1px solid rgba(221, 232, 245, 0.95);
    box-shadow: var(--soft-shadow);
  }

  .step-no {
    display: inline-flex;
    width: 36px;
    height: 36px;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
    border-radius: 12px;
    background: #eaf3ff;
    color: var(--deep-blue);
    font-size: 15px;
    font-weight: 900;
  }

  .step-card h3 {
    margin: 0 0 8px;
    font-size: 20px;
    font-weight: 900;
    color: #1b2f47;
  }

  .step-card p {
    margin: 0;
    color: var(--muted);
    font-size: 15px;
    font-weight: 600;
  }

  .experience-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 22px;
  }

  .experience-card {
    min-height: 278px;
    padding: 30px 28px;
    border-radius: 26px;
    background: #fff;
    border: 1px solid var(--line);
    box-shadow: var(--soft-shadow);
    position: relative;
    overflow: hidden;
    transition: transform 0.22s ease, box-shadow 0.22s ease;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 18px 44px rgba(16, 43, 92, 0.12);
    }

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 4px;
      background: linear-gradient(90deg, var(--blue), var(--cyan));
    }

    h3 {
      margin: 0 0 12px;
      color: #17243a;
      font-size: 24px;
      font-weight: 900;
    }

    p {
      margin: 0;
      color: var(--muted);
      font-size: 16px;
      font-weight: 600;
    }
  }

  .icon-box {
    width: 48px;
    height: 48px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 18px;
    border-radius: 16px;
    background: #f0f7ff;
    color: var(--deep-blue);
    font-size: 18px;
    font-weight: 900;
  }

  .solve {
    display: inline-flex;
    margin-top: 22px;
    padding: 8px 13px;
    border-radius: 999px;
    background: #fff5e6;
    color: #a55a00;
    font-size: 14px;
    font-weight: 800;
  }

  .flow-panel {
    display: grid;
    grid-template-columns: 280px 1fr;
    gap: 22px;
    align-items: stretch;
  }

  .flow-copy {
    padding: 32px;
    border-radius: 26px;
    color: #fff;
    background: linear-gradient(160deg, #0e5885 0%, #0a3357 100%);
    box-shadow: var(--shadow);

    h3 {
      margin: 0 0 14px;
      font-size: 28px;
      line-height: 1.25;
      font-weight: 900;
    }

    p {
      margin: 0;
      color: rgba(255, 255, 255, 0.82);
      font-size: 16px;
      font-weight: 600;
    }
  }

  .flow-steps {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px;
  }

  .flow-step {
    padding: 26px 20px;
    border-radius: 22px;
    background: #fff;
    border: 1px solid var(--line);
    box-shadow: var(--soft-shadow);
    position: relative;

    &::after {
      content: "";
      position: absolute;
      right: -13px;
      top: 50%;
      width: 24px;
      height: 2px;
      background: #bfd6ef;
    }

    &:last-child::after {
      display: none;
    }

    strong {
      display: block;
      margin-bottom: 10px;
      color: var(--deep-blue);
      font-size: 15px;
      font-weight: 900;
    }

    h3 {
      margin: 0 0 8px;
      color: #1b2f47;
      font-size: 19px;
      font-weight: 900;
    }

    p {
      margin: 0;
      color: var(--muted);
      font-size: 14px;
      font-weight: 600;
    }
  }

  .value-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 18px;
  }

  .value-card {
    padding: 30px 22px;
    border-radius: 26px;
    background: rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.22);
    text-align: center;
    box-shadow: 0 12px 34px rgba(0, 0, 0, 0.10);

    strong {
      display: block;
      margin-bottom: 10px;
      color: #fff;
      font-size: 28px;
      line-height: 1.2;
      font-weight: 900;
    }

    span {
      color: rgba(255, 255, 255, 0.78);
      font-size: 15px;
      font-weight: 650;
    }
  }

  .cta {
    margin-top: 34px;
    padding: 34px;
    border-radius: 26px;
    background: rgba(255, 255, 255, 0.10);
    border: 1px solid rgba(255, 255, 255, 0.14);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;

    h2 {
      margin: 0 0 8px;
      color: #fff;
      font-size: 32px;
      font-weight: 900;
    }

    p {
      margin: 0;
      color: rgba(255, 255, 255, 0.78);
      font-size: 16px;
      font-weight: 600;
    }
  }

  @media (max-width: 1120px) {
    .hero-inner,
    .intro-layout,
    .flow-panel {
      grid-template-columns: 1fr;
    }

    .hero-inner {
      padding: 48px 0;
    }

    .reservoir-visual {
      height: 320px;
    }

    .experience-grid,
    .value-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .flow-steps {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .flow-step::after {
      display: none;
    }
  }
}
</style>
